import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetSpecsVehicleService extends Service {
  constructor({mapper: fromSpecsParamsToSearchUrlValueObjectMapper, repository: httpVehiclesRepository}) {
    super()
    this._mapper = fromSpecsParamsToSearchUrlValueObjectMapper
    this._repository = httpVehiclesRepository
  }

  @AsyncInlineError()
  async execute({nextField, params}) {
    const {url} = this._mapper.map({nextField, params}).toJSON()
    const [error, response] = await this._repository.getSpecs({nextField, url})

    if (error) return Promise.reject(error)

    return response
  }
}
